export default __webpack_public_path__ + "static/media/ic_aave_24.92f783d4.svg";